import { connect } from 'react-redux'

import RenterLiveRentFree from 'app/bond_cover/renters/status/live_rent_free'

export default connect()(RenterLiveRentFree)
